import React, {Component, Children} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as commonActions from './../../actions/commonActions';
import * as tradeBookActions from './../../actions/tradeBookActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as activityActions from './../../actions/activityActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as authActions from '../../redux/modules/auth';
import styles from './TradeBook.less';
import DatePicker from 'react-datepicker';
import Modal from 'react-modal';
import i18next from 'i18next';
import renderHTML from 'react-render-html';
import { applyStyle, applyClickActive,applyToHover,getSeparator, setDirection,unformatLang} from './../../utils/utils';
import 'react-datepicker/dist/react-datepicker.css';
import {
  ButtonToolbar,
  DropdownButton,
  MenuItem,
  Tabs,
  Tab,
  Button,
  Checkbox
} from 'react-bootstrap';
import moment from 'moment';
import appConstants from './../../appConstants';
import track from 'react-tracking';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';

let CmdtyAsk;
let CmdtyBid;
let CmdtyPair;
let CmdtyAskArray;
let CmdtyBidArray;
let CmdtyAskFontPosStart;
let CmdtyAskFontPosEnd;
let ValueDate;
let D1;
let T1;
let rateDiff;
let variationInAsk;
let variationInBid;
let fixordNo = [];
let index1=0;
let separator;
let decimal;
let decimalCount = 0;
let wsData;
// const elementsData = [
//   {"classNames":"header","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"part1TabContent","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"part2TabContent","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"lmtClose","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"rateDiff","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"mdlWrap","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"buyBg","elementType":"normal", "applyTo":"single", "tagNames":"button"},
//   {"classNames":"sellBg","elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"cmdtyType","elementType":"normal", "applyTo":"all", "tagNames":"p"},
//   {"classNames":"trdDropDown","elementType":"tag", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"dropDownList","elementType":"normal", "applyTo":"all", "tagNames":"li"},
//   {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"},
//   {"classNames":"trdComments","elementType":"normal", "applyTo":"all", "tagNames":"textarea"},
//   {"classNames":"onTop","elementType":"normal", "applyTo":"all", "tagNames":"label"}
// ];
const directionData=[
  {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"closeIconMdfy","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"msgTitle","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
  {"classNames":"cmdtyType","elementType":"normal", "applyTo":"all", "tagNames":"p"},
  {"classNames":"col3","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"col4","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdMeasureDrpDown","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"rightPart","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdDropdownInput","elementType":"normal", "applyTo":"all", "tagNames":"input"},
  {"classNames":"btnText","elementType":"normal", "applyTo":"all", "tagNames":"button"},
  {"classNames":"commentDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"submitBtn","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"lmtMeasureDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"lmtCmdtyDrpdown","elementType":"normal", "applyTo":"all", "tagNames":"div"},
  {"classNames":"trdbookText","elementType":"normal", "applyTo":"all", "tagNames":"span"}
];
@connect(
state => ({
  userDetail:state.auth.userDetail,
  trdPanelData: state.dashboardRoot.instrumentListReducer.trdPanelData,
  trdingFlag: state.dashboardRoot.tradepanelReducer.trdingFlag,
  status: state.dashboardRoot.instrumentListReducer.status,
  fixingOrdBook: state.dashboardRoot.activityReducer.fixingOrdBook,
  fixModifyFlag:state.dashboardRoot.tradeBookReducer.fixModifyFlag,
  closeFixModifypopup:state.dashboardRoot.tradeBookReducer.closeFixModifypopup,
  socketData: state.dashboardRoot.instrumentListReducer.socketData,
  socketDataStatic:state.dashboardRoot.instrumentListReducer.socketDataStatic,
  check: state.dashboardRoot.instrumentListReducer.check,
  cmdtyArr: state.dashboardRoot.instrumentListReducer.cmdtyArr,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
  stkWiseMarkup:state.dashboardRoot.instrumentListReducer.stkWiseMarkup,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  language:state.dashboardRoot.commonReducer.language,
  stkWiseMarkupRandomNo:state.dashboardRoot.instrumentListReducer.stkWiseMarkupRandomNo,
  orderStatus:state.dashboardRoot.tradepanelReducer.orderStatus,
  validFixingOrders:state.dashboardRoot.dashboardReducer.validFixingOrders,
}),{...tradeBookActions,
    ...tradepanelActions,
    ...instrumentListActions,
    ...activityActions,
    ...dashboardActions,
    ...commonActions,
    ...authActions})
 
@track(() => ({}))
    
export default class ModifyFIXOrderComponent extends Component {
  static propTypes =
   {
     closeFixModifypopup: PropTypes.func,
     fixModifyFlag:PropTypes.bool,
     setOrdersCTID:PropTypes.func,
     handleFixingModal:PropTypes.func,
     stkWiseMarkup:PropTypes.object,
     stkWiseMarkupRandomNo:PropTypes.Number,
     validateOrder:PropTypes.func,
   };
   state = {
    cmdtyList:[],
    selectedFixing:'',
    selectedFixingCode:'',
    selectedFixingTime:'',
    selectedCmdtyId:'',
    selectedCmdty:'',
    fixingDate:moment(),
    dealTypevalue:'',
    dealType:1,
    quantity:"",
    DFFIX:[],
    stkList:[],
    selectedStkCode:'',
    showFixDialog:false,
    selectedMeasureFix: '',
    DFFIX:[],
    COM:null,
    FIXModel: false,
    cmdtyIndex:0,
    errorMsg:'',
    CTID:'',
    ordNo:'',
    stkWiseAskMarkup:0,
    stkWiseBidMarkup:0,
    showPrice:'',
    disableSubmit:false,
	  MEASURE:[],
    convFactor:null,
    orderNo:''
  }

  constructor(props){
    super(props);
    this.afterOpenModal = this.afterOpenModal.bind(this);
  }

  componentWillMount() {
    fixordNo = this.props.selectFixRow;
    const selectedOrd = fixordNo[0];
    let orderDetails = this.props.fixingOrdBook.fixingOrdMap.get(selectedOrd.orderNo);
    //let fixingDate = moment(orderDetails.fixingDate,"DD-MMM-YYYY").format('DD-MM-YYYY');
    this.setState({
      fixingDate:orderDetails.fixingDate,
      selectedFixing:orderDetails.fixingEvent,
      selectedFixingCode:orderDetails.fixingEventCode,
      selectedFixingTime:orderDetails.fixingTime,
      selectedCmdty:orderDetails.cmdtyPair,
      selectedCmdtyId:orderDetails.cmdtyId,
      dealTypevalue:orderDetails.deal,
      dealType:orderDetails.DT,
      quantity:orderDetails.quantity,
      selectedQuantityFix:orderDetails.quantity,
      selectedMeasureFix:orderDetails.OSC,
      remarks:orderDetails.comments,
      orderNo:orderDetails.orderNo
    });
    const length = this.props.socketDataStatic.length;
    for (let index = 0; index < length; index++) {
      const cmdty = this.props.socketDataStatic[index].I;
      const cmdtyDes = this.props.socketDataStatic[index].ID;
      if (cmdtyDes === orderDetails.cmdtyPair) {
         index1=index;
         break;
      }
    }
    D1 = this.props.socketDataStatic[index1].D1;
    this.setState({COM:parseInt(this.props.socketDataStatic[index1].B)});
    T1=this.props.socketDataStatic[index1].T1;
    this.setState({T1:T1});
    const unit = [];
    var tmpConvFactor=new Map();
    const lengthTrdData = this.props.trdPanelData.length;
    for (let index = 0; index < lengthTrdData; index++) {
      const stk_type = this.props.trdPanelData[index].stk_type;
      if (stk_type === T1) {
        unit.push(this.props.trdPanelData[index].C);
        tmpConvFactor.set(this.props.trdPanelData[index].C,this.props.trdPanelData[index].F)
      }
    }
    this.getStkWiseMarkup(orderDetails.OSC,this.props.socketDataStatic[index1].I,this.props.stkWiseMarkup);
    this.setState({convFactorLM:tmpConvFactor});
    this.setState({MEASURE:unit});
    for (let index = 0; index < lengthTrdData; index++) {
      const stk_type = this.props.trdPanelData[index].stk_type;
      const type = this.props.trdPanelData[index].C;
      if (T1 === stk_type && type === orderDetails.OSC) {
        const DF = this.props.trdPanelData[index].DF;
        const conv_Factor = this.props.trdPanelData[index].F;
        const DFParse=JSON.parse(DF);
        this.setState({DFFIX:DFParse});
        this.setState({convFactor:conv_Factor});
      }else if((this.props.socketDataStatic[index1].B===1&&this.props.socketDataStatic[index1].C===1)||
      (this.props.socketDataStatic[index1].B===1&&this.props.socketDataStatic[index1].C===2)){
        const DF=this.props.socketDataStatic[index1].DF;
        const DFParse=JSON.parse(DF);
        this.setState({DFFIX: DFParse});
      }
    }
    const showPrice = this.props.userDetail.showPrice===undefined||this.props.userDetail.showPrice==="undefined"?"BOTH":this.props.userDetail.showPrice;
    this.setState({showPrice:showPrice});
    if((orderDetails.deal === 'BUY'&&showPrice!=='ASK')||(orderDetails.deal === 'SELL'&&showPrice!=='BID')){
      if(showPrice!=='BOTH'){
        this.setState({disableSubmit:true});
      }
    }
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('closeBtn')[0], "classNames":"closeBtn"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtSubmit")[0], "classNames":"lmtSubmit"},
      {"elmToHover":thisComponent.getElementsByClassName("lmtClose")[0], "classNames":"lmtClose"},
      {"elmToHover":thisComponent.getElementsByClassName("dropDownList")[0], "classNames":"dropDownList"}
    ];
    ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    separator = getSeparator(navigator.language,'group');
    decimal = getSeparator(navigator.language,'decimal');
    fixordNo = this.props.selectFixRow;
    const selectedOrd=fixordNo[0];
    let orderDetails = this.props.fixingOrdBook.fixingOrdMap.get(selectedOrd.orderNo);
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.stkWiseMarkupRandomNo !== this.props.stkWiseMarkupRandomNo){
      this.getStkWiseMarkup(this.state.selectedMeasureFix,this.state.selectedCmdtyId,nextProps.stkWiseMarkup);
    }
    if(nextProps.userDetail.showPrice!==this.state.showPrice){
      if(nextProps.userDetail.showPrice!==undefined&&nextProps.userDetail.showPrice!=="undefined"){
        const showPrice = nextProps.userDetail.showPrice===undefined||nextProps.userDetail.showPrice==="undefined"?"BOTH":nextProps.userDetail.showPrice;
        this.setState({showPrice:showPrice});
        fixordNo = this.props.selectFixRow;
        const selectedOrd=fixordNo[0];
        let orderDetails = this.props.fixingOrdBook.fixingOrdMap.get(selectedOrd.orderNo);
        if((orderDetails.deal === 'BUY'&&showPrice!=='ASK')||(orderDetails.deal === 'SELL'&&showPrice!=='BID')){
          if(showPrice!=='BOTH'){
            this.setState({disableSubmit:true});
          }else{
            this.setState({disableSubmit:false});
          }
        }else{
          this.setState({disableSubmit:false});
        }
      }
    }
  }

  getStkWiseMarkup = (stk_code,cmdty,stkWiseMarkup) =>{
    try{
      if(stk_code!==undefined && stk_code!==""){
        if(stkWiseMarkup!==null){
          let stkCodeMarkup=stkWiseMarkup.get(cmdty);
          for(let i=0;i<stkCodeMarkup.length;i++){
            if(stkCodeMarkup[i].SC===stk_code){
              this.setState({stkWiseAskMarkup: stkCodeMarkup[i].ASK,stkWiseBidMarkup: stkCodeMarkup[i].BID});
            }
          }
        }
      }else{
        this.setState({stkWiseAskMarkup: 0,stkWiseBidMarkup: 0});
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'getStkWiseMarkup', component:"ModifyFIXOrderComponent"});
    }
  }

  checkNumberValue =(event) =>{
    try{
      if (String.fromCharCode(event.which) != separator && event.which > 31 && (event.which < 48 || event.which > 57) && (String.fromCharCode(event.which)!==separator) && (String.fromCharCode(event.which)!==decimal) && (event.which !== 107) && (event.which !== 75) && (event.which !== 109) && (event.which !== 77)){
          event.preventDefault();
        }
      if(event.target.value.indexOf(decimal)===-1){
            decimalCount = 0;
      }
      // if(event.which === separator.charCodeAt(0) || (event.which === decimal.charCodeAt(0) && decimalCount>=1)){
      //     event.preventDefault();
      // }
      if(event.which === decimal.charCodeAt(0)){
        decimalCount+=1;
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'checkNumberValue', component:"ModifyFIXOrderComponent"});
    }
  }

  quantitySelectionFix = (event) => {
    try{
      if(event.target.text==="")
      {
        event.target.text="0"
      }
        var check= event.target.text.slice(event.target.text.length-1);
        var tempQ= event.target.text;
      if(check.toUpperCase()==='K')
      {
        tempQ= event.target.text.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
      }else if(check.toUpperCase()==='M'){
        tempQ= event.target.text.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000000;
      }
      //convFactor
      this.setState({selectedQuantityFix: tempQ});
      this.checkInputData(this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,tempQ,this.state.remarks,this.state.selectedMeasureFix);

    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'quantitySelectionFix', component:"ModifyFIXOrderComponent"});
    }
  }

 quantityTypedFix = (event) => {
  try{
    var checkDecimal =getSeparator(navigator.language,'decimal');
    if(event.target.value.charAt(0)=== checkDecimal){
      event.target.value="0"+event.target.value;
    }
    var flag=0;
    var c=0;
    for(var i=0;i<event.target.value.length;i++){
      if(event.target.value.charAt(i)=== checkDecimal){
        flag=1;
      }
      if(flag==1){
        c++;
      }
    }
    if(c>4){
      event.target.value= this.state.selectedQuantityFix;
    }
    if (!(event.target.value.charAt(0).toUpperCase()==='K' || event.target.value.charAt(0).toUpperCase()==='M')) {
      var check= event.target.value.slice(event.target.value.length-1);
      var tempQ= event.target.value;
      if(check.toUpperCase()==='K')
      {
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000;
      }else if(check.toUpperCase()==='M'){
        tempQ= event.target.value.slice(check, -1);
        tempQ=parseFloat(tempQ)*1000000;
      }
        if(!isNaN(tempQ)){
        this.setState({selectedQuantityFix: tempQ});
          }else{
          this.setState({selectedQuantityFix: event.target.value});
        }
      }
      else{
        this.setState({selectedQuantityFix: event.target.value});
      }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'quantityTypedFix', component:"ModifyFIXOrderComponent"});
  }
 }

 onBlurFIX= (event)=> {
  try{
   var tempQ=event.target.value;
   if(tempQ===""){
     tempQ = "";
   }
   var checkDecimal =getSeparator(navigator.language,'decimal');
   if(event.target.value.charAt(0)=== checkDecimal){
     event.target.value="0"+event.target.value;
   }
   if (!(event.target.value.charAt(0).toUpperCase()==='K' || event.target.value.charAt(0).toUpperCase()==='M')) {
     var check= event.target.value.slice(event.target.value.length-1);
      tempQ= event.target.value;
      tempQ = unformatLang(tempQ);
       if(check.toUpperCase()==='K')
       {
         tempQ= event.target.value.slice(check, -1);
         tempQ=parseFloat(tempQ)*1000;
       }
       else if(check.toUpperCase()==='M')
       {
         tempQ= event.target.value.slice(check, -1);
         tempQ=parseFloat(tempQ)*1000000;
       }
       if(!isNaN(tempQ) && tempQ !=="" && tempQ !== 0)
       {

         tempQ= event.target.value;
         tempQ = unformatLang(tempQ);
         if(tempQ==="" || tempQ==="NaN" ){
           tempQ ="";
         }
         var tempQuant=Number(parseFloat(tempQ)).toLocaleString(navigator.language, {minimumFractionDigits:3, maximumFractionDigits:3});
       // var tempQuant=Number.isInteger(parseFloat(tempQ))?tempQ:Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3});
       // tempQuant=(tempQuant).replace(getSeparator(navigator.language,'group'),"");
       this.setState({selectedQuantityFix: tempQuant});
       this.checkInputData(this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,tempQuant,this.state.remarks,this.state.selectedMeasureFix);
       tempQuant=unformatLang(tempQuant);
       tempQ=parseFloat(tempQ).toFixed(2);
       }
       else{
         if(event.target.value===""){
           tempQ = "";
         }
         this.setState({selectedQuantityFix: tempQ});
         this.checkInputData(this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,tempQ,this.state.remarks,this.state.selectedMeasureFix);
       }
     }
     else{
       if(tempQ===""){
         tempQ = "";
       }
       if(!isNaN(tempQ)){
         tempQ=Number.isInteger(parseFloat(tempQ))?tempQ: Number(parseFloat(tempQ)).toLocaleString(navigator.language,{minimumFractionDigits:3,maximumFractionDigits:3});
         this.setState({selectedQuantityFix:tempQ});
         this.checkInputData(this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,tempQ,this.state.remarks,this.state.selectedMeasureFix);
       } else{
          this.setState({selectedQuantityFix:tempQ});
          this.checkInputData(this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,tempQ,this.state.remarks,this.state.selectedMeasureFix);
       }
    }
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'onBlurFIX', component:"ModifyFIXOrderComponent"});
  }
 }
  selectMeasureFix = (event) => {
    try{
      let unit = event.target.text;
      this.setState({selectedMeasureFix:unit});
      const lengthTrdData = this.props.trdPanelData.length;
      for (let index = 0; index < lengthTrdData; index++) {
        const stk_type = this.props.trdPanelData[index].stk_type;
        const type = this.props.trdPanelData[index].C;
        if (this.state.T1===stk_type && type===event.target.text) {
          const DF = this.props.trdPanelData[index].DF;
          const DFParse=JSON.parse(DF);
          this.setState({DFFIX:DFParse});
        }
      }
      this.getStkWiseMarkup(event.target.text,this.state.selectedCmdtyId,this.props.stkWiseMarkup);
      this.checkInputData(this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,this.state.selectedQuantityFix,this.state.remarks,unit);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'selectMeasureFix', component:"ModifyFIXOrderComponent"});
    }
  }

  onBlurRmk=(e)=>{
    try{
      const rmk = event.target.value;
      this.setState({remarks:rmk});
      this.checkInputData(this.state.selectedCmdtyId,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,this.state.selectedQuantityFix,rmk,this.state.selectedMeasureFix);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBlurRmk', component:"ModifyFIXOrderComponent"});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
     if(nextProps.check !== this.props.check){
          return true;
      }
     if(nextState.showFixDialog !== this.state.showFixDialog){
       return true;
     }
     if(nextState.errorMsg !== this.state.errorMsg){
       return true;
     }
     if(nextState.selectedMeasureFix !== this.state.selectedMeasureFix){
       return true;
     }
     if(nextState.selectedQuantityFix !== this.state.selectedQuantityFix){
       return true;
     }
     if(nextState.DFFIX !== this.state.DFFIX){
       return true;
     }
     if(nextState.COMLM !== this.state.COMLM){
      return true;
     }
     if(nextState.FIXModel !== this.state.FIXModel){
      return true;
     }
     if(nextProps.trdingFlag !== this.props.trdingFlag){
       return true;
     }
     if(nextProps.status !== this.props.status){
       return true;
     }
     if(nextProps.fixingOrdBook !== this.props.fixingOrdBook){
       return true;
     }
     if(nextProps.fixModifyFlag !== this.props.fixModifyFlag){
        return true;
      }
     if(nextState.remarks !== this.state.remarks){
       return true;
     }
     if(nextState.showPrice !== this.state.showPrice){
       return true;
     }
     return false;
  }

  closeFixModal = (event) => {
    try{
      this.setState({showFixDialog: false});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeFixModal', component:"ModifyFIXOrderComponent"});
    }
  }

  closeFixingOrdpopup = (event) => {
    try{
      this.props.closeFixModifypopup(false);
      this.props.handleFixingModal(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeFixingOrdpopup', component:"ModifyFIXOrderComponent"});
    }
  }

  fixOrderValidate = () =>{
    try{
      var selectedMeasure=this.state.selectedMeasureFix;
      var selectedQuantity =  unformatLang(this.state.selectedQuantityFix);
      let flag = 0;
      selectedQuantity=selectedQuantity+"";
      var tempQ= selectedQuantity;
      var check= selectedQuantity.slice(selectedQuantity-1);
      if(this.props.orderStatus === 2 || this.props.orderStatus === 3){
        this.setState({errorMsg:"orderCannotBeplacedfortheMoment"});
        flag=1;
      }
      if(check.toUpperCase()==='K')
      {
        tempQ= selectedQuantity.slice(check, -1);
        tempQ=parseInt(tempQ)*1000;
      }
      if(this.state.COM===1){
        selectedMeasure="";
      }
      var error = '';
      this.setState({errorMsg:""});
      if(parseInt(this.props.status) !== 0){
        flag=1;
        this.setState({errorMsg:"noRatesMsg"});
      }
      if(parseFloat(tempQ) === 0){
        flag=1;
        this.setState({errorMsg:"qtyNotZeroMsg"});
      }
      if((parseFloat(tempQ) === "")&&(parseFloat(tempQ) === '')){
        flag=1;
        this.setState({errorMsg:"minEnterQty"});
      }
      if(this.props.userDetail.enableCustTradeQtyRO === 1 && tempQ % 1 !== 0) {
        flag=1;
        this.setState({errorMsg:"fractionDigitErrMsg"});
      }
      if (selectedMeasure === '') {
        flag = 1;
        this.setState({errorMsg:'selectQtyTypeMsg'});
      }
      if (selectedMeasure === '' && flag!==1) {
      flag = 1;
      this.setState({errorMsg:"Please select quantity type"});
      }
      var sockCmdty=this.props.socketData.get(this.state.selectedCmdtyId);
      var askRate=parseFloat(sockCmdty.ask)-this.state.stkWiseAskMarkup;
      var bidRate=parseFloat(sockCmdty.bid)-this.state.stkWiseBidMarkup;

      var rate = this.state.dealType ===1 ? askRate : bidRate;
      var ValueDate=sockCmdty.VD;
      if(tempQ === ''){
        flag=1;
        this.setState({errorMsg:"minEnterQty"});
      }

      if(flag === 1){
        this.setState({showFixDialog:true});
      } else{
        if(this.props.userDetail.canTrade)
        {
          const user = JSON.parse(localStorage.getItem('user'));
          var CTID =user.location+"_"+user.SID+Math.floor((Math.random() * 1000000) + 1);
          this.props.setOrdersCTID(CTID);
          this.handleModifyFixOrder(this.state.selectedCmdtyId, selectedQuantity,rate,this.state.dealType,CTID,selectedMeasure,this.state.remarks,ValueDate,this.state.selectedFixingCode,this.state.selectedFixing,this.state.selectedFixingTime,this.state.orderNo);
          const showPrice = this.props.userDetail.showPrice===undefined||this.props.userDetail.showPrice==="undefined"?"BOTH":this.props.userDetail.showPrice;
          var DealType=showPrice==="ASK"||showPrice==="BOTH"?'BUY':'SELL';
          this.setState({dealTypevalue: i18next.t(DealType),showPrice:this.props.userDetail.showPrice});
          if(this.props.userDetail.storetradeqty === "0"){
            this.setState({selectedQuantityFix :""});
          }
          this.setState({remarks:""});
        }else {
          this.setState({showtrdFlagModal:true});
        }
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'fixOrderValidate', component:"ModifyFIXOrderComponent"});
    }
  }

  @track((props, state) => ({ 
    widgetDetails: { originFunction: "handleModifyFixOrder", event: appConstants.trackingEvents.MODIFY_ORDER},
    ordDetails: [wsData]
  }))

  handleModifyFixOrder = (CmdtyPair, selectedQuantity,Price,dealType,CTID,selectedMeasure,remark, ValueDate,selectedFixingCode,selectedFixing,selectedFixingTime,orderNo) => {
    try{
      selectedQuantity=selectedQuantity+"";
      var tempQ= selectedQuantity;
      var check= selectedQuantity.slice(selectedQuantity-1);
      if (check.toUpperCase() === 'K') {
        tempQ= selectedQuantity.slice(check, -1);
        tempQ=parseInt(tempQ)*1000;
      }
      let fixingDate = moment(this.state.fixingDate,"DD-MMM-YYYY").format('YYYY/MM/DD');
      let processedData={
        "IID":CmdtyPair,
        "PQ":tempQ,
        "DT":dealType,
        "R":Price,
        "FD":fixingDate,
        "CTID":CTID,
        "SC":selectedMeasure,
        "RMK":remark,
        "VD":ValueDate,
        "FC":selectedFixingCode,
        "FN":selectedFixing,
        "FT":selectedFixingTime,
        "OrderNo":orderNo
      };
      const user = JSON.parse(localStorage.getItem('user'));
      const AccDet=JSON.parse(localStorage.getItem('DFA'));
      if (user === null) {
        dispatch(sessionTimeout());
      }
      const platform = localStorage.getItem('platform');
      let priceValue = Price;
      let quant = tempQ;

      if (!priceValue) {
        priceValue = 0;
      }
      if (quant === '') {
        quant = 0;
      }

      wsData={
        "MT": "MODIFY_ORDER",
        "UID":user.UID,
        "UD": user.UD,
        "UCD":user.trdCode,
        "IID": CmdtyPair,
        "PQ": parseFloat(quant),
        "DT": dealType,
        "R": parseFloat(priceValue),
        "OT": 4,
        "CID": user.location,
        "AC": AccDet.C,
        "AD": AccDet.D,
        "SC": selectedMeasure,
        "OMT": 2,
        "PCT": 20,
        "RMK": remark,
        "VD": ValueDate,
        "SID":user.SID,
        "FC": selectedFixingCode,
        "FN": selectedFixing,
        "FT": selectedFixingTime,
        "CTID": CTID,
        "MD": -1,
        "FD": fixingDate,
        "OrderNo": orderNo
      };

      let apiValidateData=[{"inputData":this.state.inputData},{"processedData":processedData},{"wsData":wsData}]
      this.props.validateOrder(JSON.stringify(apiValidateData))

      this.props.handleModifyFIXOrder(CmdtyPair, tempQ, dealType, Price,fixingDate, CTID, selectedMeasure,remark,ValueDate,selectedFixingCode,selectedFixing,selectedFixingTime,orderNo);
      this.props.closeFixModifypopup(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'handleModifyFixOrder', component:"ModifyFIXOrderComponent"});
    }
  }

  checkInputData=(cmdtyId,FC,FN,FT,qty,rmk,selectedMeasureFix)=>{
    try{
      let inputData={
      "IID":this.state.selectedCmdtyId,
      "FC":this.state.selectedFixingCode,
      "FN":this.state.selectedFixing,
      "FT":this.state.selectedFixingTime,
      "PQ":qty,
      "RMK":rmk,
      "SC":selectedMeasureFix
      };
      this.setState({inputData:inputData});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'checkInputData', component:"ModifyFIXOrderComponent"});
    }
  }

  afterOpenModal() {
    try{
      const thisComponent = this.refs.modifyFixOrd;
      //const allCssStyleRules = this.props.selectedCssColorTheme;
      // const elementsData = [
      //   {"classNames":"header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"lmtSubmit","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      //   {"classNames":"lmtClose","elementType":"normal", "applyTo":"single", "tagNames":"button"},
      //   {"classNames":"msg","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      //   {"classNames":"closeBtn","elementType":"normal", "applyTo":"single", "tagNames":"div"},
      // ];
      // applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {"classNames":"header", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"commonMsgDir", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"trdCloseIcon", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
        {"classNames":"lmtMeasureDiv","elementType":"normal", "applyTo":"all", "tagNames":"div"}
      ];
      setDirection(thisComponent,directionData,this.props.selectedLang);
      const hoverElementsClassNames = [
          {"elmToHover":thisComponent.getElementsByClassName("closeBtn")[0], "classNames":"closeBtn"},
          {"elmToHover":thisComponent.getElementsByClassName(styles.savetmpBtn)[0], "classNames":styles.savetmpBtn},
          {"elmToHover":thisComponent.getElementsByClassName(styles.exitBtn)[0], "classNames":styles.exitBtn},
          {"elmToHover":thisComponent.getElementsByClassName(styles.cancelBtn)[0], "classNames":styles.cancelBtn}
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'afterOpenModal', component:"ModifyFIXOrderComponent"});
    }
  }
  render() {
    const { selectedMeasureFix, MEASURE, DFFIX, selectedQuantityFix ,COM} = this.state;
    const closeIcon = <MUIIconWithTooltip icon={'Close'} className={`closeBtn trdCloseIcon`} title={i18next.t("close")}/>
    return (
      <React.Fragment>
        <Modal isOpen={this.state.showFixDialog} className={styles.warningModal} id="modifylmtWarningModal" onAfterOpen={this.afterOpenModal}>
          <div ref="modifyFixOrd" className="mdlWrap" >
            <div className={`${styles.header} header`}>
              <span className={`${styles.msgTitle}`}>{i18next.t("error")}</span>
              <span onClick={this.closeFixModal} className={`${styles.closeImg} closeIcon commonCloseIcon`}>
                {closeIcon}
              </span>
            </div>
            <div className={`${styles.msg} commonMsgDir`}>
              {this.state.errorMsg && this.state.errorMsg != "" ? <p>{renderHTML(i18next.t(this.state.errorMsg))}</p> : null}
            </div>
          </div>
        </Modal>
        <div id="fixOrdr">
          <div className={`${styles.header} header`}>
            <span className={`${styles.msgTitle} msgTitle`}>{i18next.t('Modify Fixing Order')}</span>
            <span id="fixCloseModalIcon" className={`${styles.closeImg} closeIcon closeIconFix`} onClick={this.closeFixingOrdpopup}>{closeIcon}</span>
          </div>
          <div className={styles.trdwrapper}>
            <div className={styles.lmtWidgetwrapper}>
              <div className="row mt-4">
                <div className="col-xs-3 form-group hangLbl">
                  <label className="onTop">Fixing Date</label>
                  <div id="validityDatePicker">
                    <div className="datepickerInputBox">
                      {/* To Check Impact */}
                      <DatePicker id="datePicker" className="form-control trdDropdownInput datePickerIcon" ref="datepickerRef" dateFormat="DD-MM-YYYY" selected={moment(this.state.fixingDate)} minDate={new Date()} disabled/>
                    </div>
                  </div>
                </div>

                <div className="col-xs-9 form-group">
                  <ButtonToolbar>
                    <DropdownButton id="fixingEvent" className="form-control trdDropDown btnText" title={this.state.selectedFixing} disabled>
                  {this.props.validFixingOrders.map((item,index) => {
                    return (
                      <MenuItem eventKey={item.FC} onClick={()=>this.fixingSelection(item)}>{item.FN}</MenuItem>
                    );
                  })}
                    </DropdownButton>
                  </ButtonToolbar>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-auto form-group">
                  <ButtonToolbar>
                    <DropdownButton className={`${styles.cmdtyPairtrdDropDown} form-control trdDropDown btnText`} title={this.state.selectedCmdty} disabled>
                    {this.state.cmdtyList.map((item,index) => {
                    return (
                      <MenuItem eventKey={item.ID} onClick={()=>this.cmdtySelection(item.ID, item.DESC)}>{item.DESC}</MenuItem>
                    );
                    })}
                    </DropdownButton>
                  </ButtonToolbar>
                </div>

                <div className="col-auto form-group">
                  <ButtonToolbar>
                    <DropdownButton className="form-control trdDropDown btnText" title={i18next.t(this.state.dealTypevalue)} disabled>
                    <MenuItem onClick={() =>this.onSelectDealType("BUY", 1)}>{i18next.t("BUY")}</MenuItem>
                    <MenuItem onClick={() =>this.onSelectDealType("SELL", 0)}>{i18next.t("SELL")}</MenuItem>
                    </DropdownButton>
                  </ButtonToolbar>
                </div>

                <div className="col form-group">
                  <ButtonToolbar>
                    <DropdownButton className="form-control trdDropDown btnText ">
                    {DFFIX.map((qntity) => {
                      return (
                        <MenuItem onClick={this.quantitySelectionFix} id="lmtOrdQauntityMenu" className="dropDownList" >{qntity}</MenuItem>
                      );
                    })}
                    </DropdownButton>
                  </ButtonToolbar>
                  <input type="text" id="lmtDropQuantity" className={`${styles.lmtDropdownInput} trdDropdownInput qtyInput`} onBlur={this.onBlurFIX} value={selectedQuantityFix} onChange={this.quantityTypedFix} onKeyPress={this.checkNumberValue} placeholder={i18next.t("quantity")} autoComplete="off" />
                </div>

                { COM !== 1 ?
                <div className="col-auto qtyUnits">
                  <ButtonToolbar>
                    <DropdownButton className="form-control trdDropDown btnText" title={selectedMeasureFix}>
                    {MEASURE && MEASURE.map((unitMeasure) => {
                      return (
                        <MenuItem onClick={this.selectMeasureFix} id="lmtOrdSelectMeasure" className="dropDownList" >{unitMeasure}</MenuItem>
                      );
                    })}
                    </DropdownButton>
                  </ButtonToolbar>
                </div>:null}
              </div>

              <div className="row mt-3">
                <div className="col-xs-12 form-group">
                  <input type="text" id="comments" className="form-control trdComments" value={this.state.remarks} onChange={this.onBlurRmk} placeholder="Comments" autoComplete="off" />
                </div>
              </div>

              <div className="row justify-content-end mt-3">
                <div className={`row`}>
                  <ButtonToolbar className="mr-3">
                    <Button id="proceedbtn" className={this.state.disableSubmit===true ? `lmtSubmit ${styles.button} ${styles.disabled}` : `lmtSubmit ${styles.button} ${styles.submitBtn}`} onClick={() => this.fixOrderValidate()}>{i18next.t("proceed")}</Button>
                  </ButtonToolbar>

                  <ButtonToolbar className="mr-3">
                    <Button id="cancelbtn" className={`lmtClose ${styles.button} ${styles.clearBtn}`} onClick={this.closeFixingOrdpopup}>{i18next.t("cancel")}</Button>
                  </ButtonToolbar>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
